import { RouterParamType } from "@/model/navModel";
import React, { FC } from "react";
import { YhBox } from "@/components/YhBox";
import FontIcon from "@/components/YhIcon";
import { useShipmentDetailModel } from "../shipmentDetailModel";

export const Steps: FC<RouterParamType> = (detailsInfo) => {
    const {
        logFormVal: { testTime, bookingTime, deliveryTime, clearTime, presentationTime, ladingTime, shipmentTime, releaseTime, carryTime }
    } = useShipmentDetailModel(({ logFormVal }) => [logFormVal]);


    //是否是完成的
    const isFinishClassName = (bool: boolean) => {
        return 'steps-item ' + (bool ? 'steps-finish' : '')
    }
    //时间转换
    const formatTime = (time: moment.Moment | null | string): string => {
        return time instanceof Object ? time.format('YYYY-MM-DD') : ""
    }
    //时间转换前一天
    function getNextDate(date: string, day: number) {
        if (!date) return "";
        let dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
    };

    return (
        <YhBox title=" " style={{ marginBottom: "10px" }}>
            <div className="yh-steps-container">
                <div className="steps-wrap">
                    <div className={isFinishClassName(!!testTime)}> 
                        <div className="steps-icon">
                            <div><FontIcon type="icon-shangjianyuhaiguanshiwuguanli" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                商检
                            </span>
                            <div className="steps-time">
                                {testTime && formatTime(testTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!bookingTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-dingcang" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                订舱
                            </span>
                            <div className="steps-time">
                                {bookingTime && formatTime(bookingTime)}
                            </div>
                        </div>
                    </div>
                    {/* <div className={isFinishClassName(!!carryTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-chuku" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                出库
                            </span>
                            <div className="steps-time">
                                {carryTime && getNextDate(formatTime(carryTime), -1)}
                            </div>
                        </div>
                    </div> */}
                    <div className={isFinishClassName(!!carryTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-zhuangguijihua" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                装柜
                            </span>
                            <div className="steps-time">
                                {carryTime && formatTime(carryTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!releaseTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-baoguandanguanli" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                报关放行
                            </span>
                            <div className="steps-time">
                                {releaseTime && formatTime(releaseTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!shipmentTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-lunchuan" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                装船
                            </span>
                            <div className="steps-time">
                                {shipmentTime && formatTime(shipmentTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!ladingTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-qingdan" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                提单
                            </span>
                            <div className="steps-time">
                                {ladingTime && formatTime(ladingTime)}
                            </div>
                        </div>
                    </div>
                    {/* <div className={isFinishClassName(!!presentationTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-xiaoshoudingdan1" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                交单/寄单
                            </span>
                            <div className="steps-time">
                                {presentationTime && formatTime(presentationTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!clearTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-qingguanbaoguan" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                清关
                            </span>
                            <div className="steps-time">
                                {clearTime && formatTime(clearTime)}
                            </div>
                        </div>
                    </div>
                    <div className={isFinishClassName(!!deliveryTime)}>
                        <div className="steps-icon">
                            <div><FontIcon type="icon-rukuriqi" /></div>
                        </div>
                        <div className="steps-content">
                            <span className="steps-title">
                                入库时间
                            </span>
                            <div className="steps-time">
                                {deliveryTime && formatTime(deliveryTime)}
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </YhBox>
    )
}